<div id="ht">
  <div id="main-cnt">

      <ion-header class="main-header block">
          <ion-toolbar class="blues-nav">
            <ion-buttons slot="start" class="nav-content">
              <div size="2" class="nav-back">
                <span class="custom-icon-back-arrow-icon" (click)="back()">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </span>
                <span class="breadcrumb">AMMINISTRATORE - COMMERCIALE</span>
              </div>
            </ion-buttons>
            <div slot="end" class="notification-div">
                  <ion-avatar class="menu-user-icon" (click)="openPage('/my-profile')">
                      <img [src]="sessionService?.user?.profileImg|s3Link">


                  </ion-avatar>
              </div>
          </ion-toolbar>
          <br>

          <!-- edit da qui... -->
          <img class="main-logo svg-white" src="./assets/imgs/logo-blu.svg">
          <!-- ...a qui -->
      </ion-header>


      <ion-content class="main-content">
          <div class="scroller-container">
              <div class="content-scroller">
                  <div class="content">
                      <!-- edit da qui... -->

                          <app-agent-home-menu></app-agent-home-menu>

                      <!-- ...a qui -->
                  </div>
              </div>
          </div>
      </ion-content>

  </div>
</div>
